import * as types from '../types'
import router from "../../router";
let http = require('../../assets/js/http');


const state = {
  operatorDetail:{}
};

const getters = {
  opDetaiul:()=>{
    return state.operatorDetail
  }
};

const actions = {
      //获取运营商详情
  getOperatorDetail: ({commit},playload) => {
    http.operatorDetail(playload.page, {},function (response) {
      commit(types.GETOPETATOR,{operatorDetail:response.data.result})
    },function (response) {
      playload.page.$message.error(response.data.result);
    })
  },
};
const mutations = {
  [types.GETOPETATOR](state,{operatorDetail}){
    state.operatorDetail = operatorDetail
  },
};
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/operator.js